/**
 * Umami Analytics 헬퍼
 */

const isPWA = typeof window !== 'undefined' && (
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true
);

export const track = (event, data) => window.umami?.track(event, data);

export const identify = (id, data) => {
  const payload = { userId: id, ...data, platform: isPWA ? 'pwa' : 'browser' };
  if (window.umami) {
    window.umami.identify(payload);
    return;
  }
  // Umami 스크립트 로드 대기 (defer)
  const timer = setInterval(() => {
    if (window.umami) {
      window.umami.identify(payload);
      clearInterval(timer);
    }
  }, 200);
  setTimeout(() => clearInterval(timer), 5000);
};
